import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { ROUTES } from '@/constants/routes';

/**
 * StoreGuard (EG-355 §3) — chỉ áp dụng cho role `cashier`. Cashier có shift
 * lock theo store (JWT.sid), nếu chưa chọn store → redirect /auth/select-store.
 *
 * Owner / manager / inventory / viewer đa store mặc định, KHÔNG cần guard này.
 *
 * Wrap quanh các route business cần biết storeId (POS, inventory, orders).
 * Place sau AuthGuard (PrivateRoute), trước AppLayout.
 */
export function StoreGuard({ element }: { element: React.ReactNode }) {
  const { user } = useAuth();
  const location = useLocation();

  if (user?.role === 'cashier' && !user?.storeId) {
    // Lưu pathname để select-store xong navigate lại đúng nơi.
    return (
      <Navigate
        to={ROUTES.auth.selectStore}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <>{element}</>;
}
